/*
*
* Version : 1.0.0
* 04/09/2016 - 10h18
*
*! Octave Web7 !*/

(function() {
  'use strict';

  angular
    .module('directive.truncate', [])

    /* @ngInject */
    .directive('truncate', function () {
      return {
        scope: {
          maxHeight: '<'
        },
        restrict: 'A',
        link: function(scope, element, attrs) {
          angular.element(document).ready(function() {
            element.dotdotdot({
              height: scope.maxHeight,
              watch: 'window',
              after: 'a.readmore',
              callback: function(isTruncated, orgContent) {
                $(this).addClass('active');
              }
            });
          });
        }
      };

    });

})();